import { dark } from "constants/palette";

const styles = {
  default: { color: dark }
};

export default styles;
